import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import EstadoForm from '../EstadoForm';

function EstadoEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <EstadoForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </EstadoForm>
    </Edit>
  );
}

export default EstadoEdit;
